import { ToolCallStreamAssembler } from './ToolCallStreamAssembler'
import { isSuccessfulStreamStatus } from './StreamLifecycle'
import { attunewiseServer } from './AttunewiseServer'

export const streamReply = (url, data, token, opts) => {
  //console.log('streamReply', opts)
  const { onContent, onDone, onError, resolve, reject } = opts
  const xhr = new XMLHttpRequest();
  //console.log('POST', url, data, opts)
  xhr.open('POST', url)
  xhr.withCredentials = new URL(url, window.location.href).origin ===
    new URL(attunewiseServer, window.location.href).origin
    xhr.setRequestHeader('Content-Type', 'application/json')
  xhr.setRequestHeader('Authorization', 'Bearer ' + token)
  let contentLength = 0
  let bufferString = ''
  const dataPrefix = 'data: '
  const doneData = `${dataPrefix}[DONE]`
  let content = ''
  let usage
  let closed = false
  let settled = false
  const toolCallAssembler = new ToolCallStreamAssembler()
  xhr.onprogress = e => {
    if (closed) return
    const chunk = xhr.responseText.substring(contentLength)
    contentLength += chunk.length
    bufferString += chunk 
    let end = bufferString.lastIndexOf('\n\n')
      ////console.log('end', end)
    let dataString
    if (end > 0) {
      dataString = bufferString.substring(0, end + 2)
      bufferString = bufferString.substring(end + 2)
    }
    if (dataString) {
      //console.log('dataString', dataString)
      try {
        const isFinal = dataString.includes(doneData)
        const dataJsonLines = dataString
              .split(doneData)
              .join('')
              .trim()
              .split(dataPrefix)
              .filter((v) => !!v) // Remove empty lines
        const contentSnippets = dataJsonLines.map((dataJson) => {
          let parsed
          try {
            parsed = JSON.parse(dataJson)
          } catch (err) {
            console.log(dataJson)
            console.error(err)
            return
          }
          //console.log(parsed)
          const { choices } = parsed
          if (choices) {
            if (parsed.usage) {
              usage = parsed.usage
            }
            const [choice] = choices
            if (choice && choice.delta.text) {
              choice.delta.content = choice.delta.text
              delete choice.delta.text
            }
            if (choice && choice.delta && choice.delta.content) {
              content += choice.delta.content
            }
            if (choice && choice.delta && choice.delta.tool_calls) {
              for (const tool_call of choice.delta.tool_calls) {
                try {
                  toolCallAssembler.process(tool_call)
                } catch(err) {
                  console.error(err)
                }
              }
            }
          }
          return parsed
        })
        for (const snip of contentSnippets) {
          //console.log("content so far", content)
          onContent(snip)
        }
      } catch (err) {
        console.error(err)
      }
    }
  }
  xhr.onreadystatechange = () => {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      if (closed || settled) return
      const status = xhr.status;
      if (isSuccessfulStreamStatus(status)) {
        settled = true
        if (onDone) onDone(xhr);
        if (resolve) resolve({
          message: {
            role: 'assistant',
            content,
          },
          usage
        })
      }
      else {
        settled = true
        const error = new Error(`Error processing stream completion (XHR readyState ${xhr.readyState}, status ${xhr.status}).`)
        if (onError) onError(error, xhr.status, xhr)
        if (reject) reject(error)
      }
    }
  }
  xhr.onerror = (event) => {
    if (closed || settled) return
    settled = true
    const error = new Error(`Error processing stream completion (XHR readyState ${xhr.readyState}, status ${xhr.status}).`)
    if (onError) {
      onError(error, xhr.status, xhr)
    }
    if (reject) reject(error)
  }
  xhr.send(JSON.stringify(data))
  return {
    abort: () => {
      console.log("XHR CLOSE")
      closed = true
      xhr.abort()
    }
  }
}
